import { useContext } from 'react';

import { useInfiniteQuery as useInfiniteQueryOriginal } from '@tanstack/react-query';
import capitalize from 'lodash/capitalize';

import { useDebug } from '../components/Debug';
import MessageContext from './MessageContext';

export const useInfiniteQuery = (
  queryKey: any,
  queryFn: any,
  options: any = {}
) => {
  const { showErrorMessage } = useContext(MessageContext);
  const { getNextPageParam } = options;
  const { empty, skeleton, error, fetching } = useDebug();
  const queryResult = useInfiniteQueryOriginal(queryKey, queryFn, {
    onError: (e: any) => {
      const queryPreview = queryKey
        .filter((el: any) => typeof el === 'string')
        .map(capitalize)
        .join('->');
      showErrorMessage(`${queryPreview} ${e.message}`);
    },
    getNextPageParam: getNextPageParam,
  });
  if (skeleton) {
    return { ...queryResult, isLoading: true, isSuccess: false };
  }

  if (fetching) {
    return { ...queryResult, isFetching: true, isRefetching: true };
  }

  if (empty) {
    return { ...queryResult, data: null };
  }

  if (error) {
    return { ...queryResult, error: 'Mock error text', isError: true };
  }

  return queryResult;
};
